import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "react-bootstrap-icons";
import Button from "../Button";
import styles from "./ExpandableText.module.scss";

interface props {
  text: string;
  className?: string;
  lines?: number;
  fontSize?: number;
}

export default function ExpandableText({
  text,
  className,
  lines = 2,
  fontSize = 12,
}: props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isExpandable, setIsExpandable] = useState(false);

  const lineHeight = fontSize + 6;

  useEffect(() => {
    if (containerRef.current && text) {
      if (containerRef.current.clientHeight > lines * lineHeight) {
        setIsExpandable(true);
      }
    }
  }, [text, lines, lineHeight]);

  return (
    <div
      className={styles.expandableTextContainer}
      style={{ fontSize: `${fontSize}px`, lineHeight: `${lineHeight}px` }}
    >
      <div
        ref={containerRef}
        className={className}
        style={
          isExpandable
            ? {
                display: "-webkit-box",
                WebkitLineClamp: lines,
                lineClamp: lines,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }
            : {}
        }
      >
        {text}
      </div>
      {isExpandable && (
        <Button
          variant="link"
          size="sm"
          className={styles.expandButton}
          onClick={() => setIsExpandable(!isExpandable)}
        >
          <ChevronDown size={12} />
        </Button>
      )}
    </div>
  );
}
